// export const SERVER_URL = "http://localhost:9090/v3/traceup";
export const SERVER_URL = "https://v3.traceup.rw/v3/traceup";
